import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './common/context/auth';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { ApolloLink } from '@apollo/client/link/core/ApolloLink';
import { onError } from '@apollo/client/link/error';
import { toast } from 'react-toastify';

const originalToastError = toast.error.bind(toast);

toast.error = ((content, options) => {
  if (typeof content === 'string' && options?.toastId == null) {
    return originalToastError(content, { ...options, toastId: content });
  }

  return originalToastError(content, options);
}) as typeof toast.error;

const httpLink = createUploadLink({
  uri: import.meta.env.VITE_REACT_APP_BACKEND_API,
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  graphQLErrors?.forEach((error) => {
    if (error.message) {
      toast.error(error.message);
    }
  });

  if (networkError && 'message' in networkError && networkError.message) {
    toast.error(networkError.message);
  }
});

const authLink = setContext(async (_, previousContext) => {
  const { headers, plug } = previousContext as {
    headers?: Record<string, string>;
    plug?: boolean;
  };
  const token = localStorage.getItem('jwtToken') || localStorage.getItem('join');

  if (plug) {
    return {
      headers: {
        ...headers,
        authorization: '',
      },
    };
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink as unknown as ApolloLink]),
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>
);
